import React from "react";

import ButtonComp from "../../buttons/buttonComp/buttonComp";
import {NavigationURLs} from "../../../functions/NavigationFunctions";

type IProps = {
    mobile?: boolean;
}

const NowSendStoryButton = (props: IProps) => {
    return (
        <React.Fragment>
            {props.mobile ? (
                <ButtonComp fullWidth={true} backgroundColor={'#D2147D'} visible={false} uppercase={true}
                            textColor={true} leftIcon={'/next/assets/images/basari_hikayeleri/white-heart.svg'}
                            rightIcon={'/next/assets/images/basari_hikayeleri/white-heart.svg'} url={NavigationURLs.successStorySend}>
                    Şimdi hikayeni gönder
                </ButtonComp>
            ) : (
                <ButtonComp fullWidth={true} backgroundColor={'#FFFFFF'} visible={false} uppercase={true}
                            textColor={false} leftIcon={'/next/assets/images/basari_hikayeleri/pink-heart.svg'}
                            rightIcon={'/next/assets/images/basari_hikayeleri/pink-heart.svg'} url={NavigationURLs.successStorySend}>
                    Şimdi hikayeni gönder
                </ButtonComp>
            )}
        </React.Fragment>
    );
}

export default NowSendStoryButton;
